<table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="dataSource" style="margin-top: 20px">

    <ng-container matColumnDef="nome">
        <th mat-header-cell *matHeaderCellDef> Familiar </th>
        <td mat-cell *matCellDef="let element"> {{element.familiar.pessoasFisica.nome}} </td>
    </ng-container>

    <ng-container matColumnDef="dataIdentificacao">
        <th mat-header-cell *matHeaderCellDef> Data Identificação </th>
        <td mat-cell *matCellDef="let element"> {{element.dataIdentificacao | dataSimples}} </td>
    </ng-container>

    <ng-container matColumnDef="dataSolucao">
        <th mat-header-cell *matHeaderCellDef> Data Solução</th>
        <td mat-cell *matCellDef="let element"> {{element.dataSolucao | dataSimples}} </td>
    </ng-container>

    <ng-container matColumnDef="vulnerabilidade">
        <th mat-header-cell *matHeaderCellDef> Vulnerabilidade </th>
        <td mat-cell *matCellDef="let element"> {{element?.situacoesVulnerabilidade?.descricao}} </td>
    </ng-container>

    <ng-container matColumnDef="solucao">
        <th mat-header-cell *matHeaderCellDef> Solução </th>
        <td mat-cell *matCellDef="let element"> {{element?.solucoes?.descricao}} </td>
    </ng-container>

    <ng-container matColumnDef="acoes">
        <th mat-header-cell *matHeaderCellDef> Ações </th>
        <td mat-cell *matCellDef="let element">
            <button *ngIf="perfilAcesso.deleta"  mat-button (click)="deletar(element)">
                <mat-icon>delete</mat-icon>
            </button>
            <button *ngIf="perfilAcesso.consulta" mat-button (click)="atualizar(element)">
                <mat-icon>create</mat-icon>
            </button>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>

<div [hidden]="!mostrarTabela">
    <mat-paginator [pageSizeOptions]="[5]" showFirstLastButtons></mat-paginator>
</div>

<ng-template #tabelaSemDados>
    <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 10px">
        {{msg}}
    </div>
</ng-template>

<div fxLayout="row" *ngIf="perfilAcesso.insere" fxLayoutAlign="end center" fxLayoutGap="16px" style="padding-top: 30px">
    <div>
        <button matTooltip="Adicionar nova vulnerabilidade" mat-fab color="primary" (click)="novo()">
            <mat-icon>add</mat-icon>
        </button>
    </div>
</div>
